import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTextarea,_vm._b({staticClass:"vd-form-input-xl",attrs:{"value":_vm.field.value},on:{"change":_vm.emitChangeEvent}},'VTextarea',_vm.field.fieldOptions,false))
}
var staticRenderFns = []

export { render, staticRenderFns }